import { useField } from "formik";

const LoginTextInput = ({ label, icon, endAdornment, labelClassName, placeholder, ...props }) => {
  const [field, meta] = useField(props);
  const isError = meta.touched && meta.error;
  return (
    <div className="flex flex-col">
      <label
        className={`p-1 mt-2 text-gray-700 ${labelClassName || 'text-lg'}`}
        htmlFor={props.id || props.name}
      >
        {label}
      </label>
      <div
        className={`relative rounded-lg border ${isError ? "" : "border-gray-300"
          }`}
      >
        {icon && (
          <div className="absolute inset-y-0 left-0 pl-2 pr-2 flex items-center pointer-events-none border border-[rgba(222,226,230,1)]-[1px]">
            {icon}
          </div>
        )}
        <input
          className={`p-2 bg-transparent outline-none ${icon ? "pl-10" : "pl-2"
            } ${endAdornment ? "pr-10" : "pr-2"}  placeholder-gray-400 placeholder:text-[14px] placeholder:pl-1`}
          {...field}
          {...props}
          placeholder={placeholder || ""}
        />
        {endAdornment && (
          <div className="absolute inset-y-0 right-0  pl-2 pr-2 flex items-center  border border-[rgba(222,226,230,1)]-[1px]">
            {endAdornment}
          </div>
        )}
      </div>
      {meta.touched && meta.error ? (
        <div className="text-red-500 text-[12px]">{meta.error}</div>
      ) : null}
    </div>
  );
};

export default LoginTextInput;